import { render, staticRenderFns } from "./CambiarPasswordController.vue?vue&type=template&id=a19e8998&"
import script from "./CambiarPasswordController.vue?vue&type=script&lang=js&"
export * from "./CambiarPasswordController.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports